module.exports = __webpack_public_path__ + "static/img/logo.8832ea74.png";